import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { Container } from "./styles";
function SkeletonComponent({ type = "rectangle", height = "50px", width = "100%", ...rest }) {
    return (_jsx(Container, { type: type, height: height, width: width, ...rest, children: _jsx("div", { "data-testid": "skeleton" }) }));
}
export const Skeleton = memo(SkeletonComponent);
//# sourceMappingURL=index.js.map